(function() {
	'use strict';

	angular.module('telestatApp').controller('MegafonInternalPhonesController',
			MegafonInternalPhonesController);

	MegafonInternalPhonesController.$inject = [ '$state', 'AlertService',
			'UIFormAccess', 'MegafonInternalPhonesService' ];

	function MegafonInternalPhonesController($state, AlertService,
			UIFormAccess, MegafonInternalPhonesService) {

		var vm = this;

		vm.UIFormAccess = UIFormAccess;

		loadAll();
		vm.loadAll = loadAll;

		function loadAll() {
			MegafonInternalPhonesService.getinternal({}, onSuccess, onError);
			function onSuccess(data, headers) {				
				vm.accounts = data.map(function(a) {
					return {
						account : a,
						error : 0,
						msg : ''
					};
				});
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

	}
})();
